import {
  normalizeFreeFirstConfig,
  isCheckoutAvailable,
  shouldShowManageSubscription,
  BASELINE_FREE_LIMITS,
  BASELINE_PRO_LIMITS,
  resolveProGenerationLimits,
  createFreeFirstTtlCache,
  loadPricingFreeFirstBundle,
} from '../../shared/freeFirstClient.js';
import { getAuthHeaders, getWebApiBase } from './webApi';

const API_BASE = getWebApiBase();
const cache = createFreeFirstTtlCache();

/**
 * @param {unknown} [fromUserOrStatus]
 */
export function resolveFreeFirst(fromUserOrStatus) {
  if (fromUserOrStatus?.freeFirst) {
    return normalizeFreeFirstConfig(fromUserOrStatus.freeFirst);
  }
  const hit = cache.get();
  if (hit.hit && hit.value?.freeFirst) return hit.value.freeFirst;
  return normalizeFreeFirstConfig(null);
}

/**
 * @param {boolean} [force]
 */
export async function fetchPricingFreeFirstBundle(force = false) {
  return loadPricingFreeFirstBundle({
    force,
    cache,
    fetchJson: async () => {
      const res = await fetch(`${API_BASE}/api/subscription/pricing`, {
        headers: getAuthHeaders(),
      });
      if (!res.ok) throw new Error(`pricing ${res.status}`);
      return res.json();
    },
  });
}

/**
 * @param {boolean} [force]
 */
export async function fetchFreeFirstConfig(force = false) {
  const bundle = await fetchPricingFreeFirstBundle(force);
  return bundle.freeFirst;
}

export function clearFreeFirstCache() {
  cache.clear();
}

export {
  isCheckoutAvailable,
  shouldShowManageSubscription,
  normalizeFreeFirstConfig,
  BASELINE_FREE_LIMITS,
  BASELINE_PRO_LIMITS,
  resolveProGenerationLimits,
};
